export enum OAuthProviderIds {
  BI_Auth0 = 'oidc.bi-auth0-sso',
  BI_Auth0_Dev = 'oidc.bi-auth0-sso-dev',
  BI_Azure = 'oidc.bi-azure-sso',
  EntraTest = 'oidc.microsoft-entra-test',
}
